import { useSelector } from "react-redux";
import { useLocation, matchPath } from "react-router-dom";
import { routes } from "../../../routes";
import { breadcrumbResolvers } from "./breadcrumbResolvers";
import { useBreadcrumbs } from "../../../hooks/useBreadcrumbs";
import { HeaderContainer } from "./headerContainer";

export const Header = (props) => {
  const location = useLocation();
  const state = useSelector((s) => s);

  const context = {};

  routes.forEach((route) => {
    if (!route.breadcrumbResolver) return;

    const match = matchPath(location.pathname, {
      path: route.path,
      exact: false,
    });

    if (!match) return;

    const resolver = breadcrumbResolvers[route.breadcrumbResolver];
    if (resolver) {
      context[route.breadcrumbResolver] = resolver(state, match.params);
    }
  });

  const breadcrumbs = useBreadcrumbs(context);

  const last = breadcrumbs[breadcrumbs.length - 1];
  const visibleBreadcrumbs = breadcrumbs.filter((bc) => !(bc.hideWhenExact && bc.isExact));

  const showBreadcrumb = last && !(last.hideWhenExact && last.isExact) && visibleBreadcrumbs.length > 1;

  return (
    <HeaderContainer
      {...props}
      breadcrumbs={{
        show: showBreadcrumb,
        items: visibleBreadcrumbs,
      }}
    />
  );
};